import { BaseAction } from "../../../core/actions/BaseAction";
import { isEmpty } from "../../../Lib/Utils/validationUtil";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IModifySearchActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/ModifySearchActionParams";

export class ModifySearchAction extends BaseAction<void, Partial<IModifySearchActionParams>> {

    override async run(): Promise<void | null> {
        try {
            const { openModal, search, searchPopupData, isPopupConfirm, isConfirm = false } = this.params!;
            if (search && !isPopupConfirm) {
                // Update the searchStatePopupAtom state in the Recoil store  
                if (searchPopupData?.oldSearch && isConfirm) {
                    let newSearch = { ...search, oldSearch: { ...search } }
                    updateRecoilState("searchStatePopupAtom", newSearch);
                }
                else {
                    if (isEmpty(searchPopupData?.passengers)) {
                        updateRecoilState("searchStatePopupAtom", { ...search, oldSearch: { ...search } });
                    } else {
                        if (openModal) {
                            updateRecoilState("searchStatePopupAtom", { ...search, oldSearch: { ...search } });
                        }
                    }
                }
            }
            if (isPopupConfirm) {
                updateRecoilState("searchStateAtom", { ...searchPopupData, passengers: search?.passengers })
            }
            if (openModal == false && !isPopupConfirm) {
                // updateRecoilState("searchStatePopupAtom", {});
                if (searchPopupData?.oldSearch?.passengers) {
                    updateRecoilState("searchStateAtom", {
                        ...search,
                        outboundDate: searchPopupData?.oldSearch?.outboundDate,
                        inboundDate: searchPopupData?.oldSearch?.inboundDate,
                        passengers: {
                            ...(searchPopupData?.oldSearch?.passengers || {}),
                        }
                    });
                }
            }
            updateRecoilState("openSearchModalAtom", openModal);

            if (isConfirm) {
                /**
                 * Set both train legs details empty
                 * Because if click on confirm from modified search then we have to start selecting train
                 * from outbound, that's why we need to clear all the legs details.
                 * This is clear only if user click on confirm search.
                 * */
                updateRecoilState("selectedTrainLegsAtom", {
                    outbound: [],
                    inbound: []
                });
            }
        } catch (error) {
            console.error("Error in ModifySearchAction:", error);
        }
    }
}

// Create a singleton instance
export const modifySearchAction = new ModifySearchAction(); 